export function apiErrorMessage(data, fallback = 'Unknown error') {
  if (data == null || typeof data !== 'object') {
    return fallback;
  }

  const error = data.error;
  if (error != null && String(error).trim()) {
    return String(error).trim();
  }

  if (Array.isArray(data.errors)) {
    const messages = data.errors
      .map((entry) => (entry == null ? '' : String(entry).trim()))
      .filter(Boolean);

    if (messages.length > 0) {
      return messages.join(', ');
    }
  }

  return fallback;
}
